module.exports = __webpack_public_path__ + "static/media/spoonerism-task (1).da3135b4.mp3";